import blackStandard from "./vessel-black-standard.svg";
import brownStandard from "./vessel-brown-standard.svg";
import darkblueStandard from "./vessel-darkblue-standard.svg";
import darkgreenStandard from "./vessel-darkgreen-standard.svg";
import darkredStandard from "./vessel-darkred-standard.svg";
import grayStandard from "./vessel-gray-standard.svg";
import lightblueStandard from "./vessel-lightblue-standard.svg";
import lightgreenStandard from "./vessel-lightgreen-standard.svg";
import lightredStandard from "./vessel-lightred-standard.svg";
import magentaStandard from "./vessel-magenta-standard.svg";
import orangeStandard from "./vessel-orange-standard.svg";
import purpleStandard from "./vessel-purple-standard.svg";
import salmonStandard from "./vessel-salmon-standard.svg";
import violetStandard from "./vessel-violet-standard.svg";
import whiteStandard from "./vessel-white-standard.svg";
import yellowStandard from "./vessel-yellow-standard.svg";

import VesselColour from "../../../Enums/VesselColour";

const iconImages = {};
iconImages[VesselColour.BLACK] = blackStandard;
iconImages[VesselColour.BROWN] = brownStandard;
iconImages[VesselColour.DARKBLUE] = darkblueStandard;
iconImages[VesselColour.DARKGREEN] = darkgreenStandard;
iconImages[VesselColour.DARKRED] = darkredStandard;
iconImages[VesselColour.GRAY] = grayStandard;
iconImages[VesselColour.LIGHTBLUE] = lightblueStandard;
iconImages[VesselColour.LIGHTGREEN] = lightgreenStandard;
iconImages[VesselColour.LIGHTRED] = lightredStandard;
iconImages[VesselColour.MAGENTA] = magentaStandard;
iconImages[VesselColour.ORANGE] = orangeStandard;
iconImages[VesselColour.PURPLE] = purpleStandard;
iconImages[VesselColour.SALMON] = salmonStandard;
iconImages[VesselColour.VIOLET] = violetStandard;
iconImages[VesselColour.WHITE] = whiteStandard;
iconImages[VesselColour.YELLOW] = yellowStandard;

export default iconImages;
